module.exports = __webpack_public_path__ + "img/Presentation16.769ae4e7.png";